/* eslint-disable import/prefer-default-export */

import { COUNTRY_REGION, PROVINCE_LOCALES, STATE_LOCALES } from './constants';

export const countryDropdownOptions = () => {
  const topCountries = ['US', 'CA'];

  const options = Object.entries(COUNTRY_REGION).map(([code, value]) => ({
    value: code,
    label: value.name,
  }));

  const sortedOptions = options.sort((a, b) => {
    const aTopIndex = topCountries.indexOf(a.value);
    const bTopIndex = topCountries.indexOf(b.value);

    const aIsTop = aTopIndex !== -1;
    const bIsTop = bTopIndex !== -1;

    // Prioritize items that are in the topCountries list
    if (aIsTop !== bIsTop) {
      return aIsTop ? -1 : 1;
    }

    // If both are in the topCountries list, sort by their index
    if (aIsTop) {
      return aTopIndex - bTopIndex;
    }

    // If neither is in the topCountries list, sort by label
    return a.label.localeCompare(b.label);
  });

  return sortedOptions;
};

export const countryDropdownOption = country => ({ value: country, label: COUNTRY_REGION[country]?.name });
export const regionDropdownOption = (country, region) => ({
  value: region,
  label: COUNTRY_REGION[country]?.regions[region],
});

export const regionDropdownOptions = country => {
  const regions = COUNTRY_REGION[country]?.regions ?? {};

  return Object.entries(regions).map(([value, label]) => ({
    value,
    label,
  }));
};

export const countryFormatter = params => COUNTRY_REGION[params.value]?.name;

export const regionFormatter = params => {
  const regions = COUNTRY_REGION[params.data.country_code]?.regions ?? {};

  return regions[params.value] ?? params.value;
};

export const regionLabel = locale =>
  STATE_LOCALES.includes(locale) ? 'State' : PROVINCE_LOCALES.includes(locale) ? 'Province' : 'Region';

export const postalCodeLabel = locale => (locale === 'en-US' ? 'Zip' : 'Postal Code');
